import { AfterViewInit, ComponentFactoryResolver, NgModule, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { RouterModule, Routes } from '@angular/router';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MediaMatcher } from '@angular/cdk/layout';
import { NavItem } from '../../../models/nav-item';
// import { AppraisalContainerComponent } from "../../appraisal-container/appraisal-container.component";
import { CommentsContainerComponent } from "../../comments-container/comments-container.component";
import { AssistantContainerComponent } from "../../assistant-container/assistant-container.component";
import { NavDataService } from '../../../shared/services/nav-data.service';
import { ContainerActionsComponent } from "../../container-actions/container-actions.component";
import { CloserContainerComponent } from "../../closer-container/closer-container.component";
import { AppraisalTableComponent } from "../../appraisal-table/appraisal-table.component";
import { ReviewComponent } from "../../review/review.component";
import { TestComponent } from "../../test/test.component";
import { DashboardContainerComponent } from "../../dashboard-container/dashboard-container.component";

@Component({
    selector: 'app-left-sidenav',
    standalone: true,
    templateUrl: './left-sidenav.component.html',
    styleUrls: ['./left-sidenav.component.scss'],
    imports: [CommonModule, RouterModule, MatSidenavModule, MatListModule, MatIconModule,
    CommentsContainerComponent, AssistantContainerComponent, ContainerActionsComponent, CloserContainerComponent,
    AppraisalTableComponent, ReviewComponent, TestComponent, DashboardContainerComponent]
})
export class LeftSidenavComponent implements OnInit, OnDestroy{
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  expandedStates: { [key: string]: boolean } = {};
  links = [
    { title: 'Dashboard', icon: 'dashboard' },
    { title: 'Reports', icon: 'bar_chart' },
    { title: 'Admin', icon: 'admin_panel_settings' }
  ];
  public navData: NavItem[] = [];

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private navDataService: NavDataService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.navDataService.getNavData().subscribe(data => {
      this.navData = data;
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onSelect() {
    // Handle link selection here, e.g., by navigating to different routes
    // console.log('Selected link:');
  }

  @ViewChild('leftSideNav') drawer!: MatSidenav;  // Non-null assertion operator

  toggle(): void {
    this.drawer.toggle();
  }

  @ViewChild('rightSidenav') rightSidenav!: MatSidenav;  // Non-null assertion operator

  toggleRightSidenav(): void {
    this.rightSidenav.toggle();
  }

  toggleItem(item: any, level: number): void {
    const key = this.getItemKey(item, level);
    this.expandedStates[key] = !this.expandedStates[key];
  }

  isExpanded(item: any, level: number): boolean {
    const key = this.getItemKey(item, level);
    return !!this.expandedStates[key];
  }

  getItemKey(item: any, level: number): string {
    return `${level}-${item.title}`;
  }

  handleExport() {
    // Implementation for exporting data
  }

  handleUpload() {
    // Implementation for uploading data
  }

  handleApprove() {
    // Implementation for approving data
  }

  handleSave() {
    // Implementation for saving data
  }
}
